<template>
  <div
    :class="{
      'electron-msg-list-page': isElectron,
      'msg-list-mobile': isH5,
      'msg-list-page': !isH5,
    }"
  >
    <div class="msg-list-count">
      <p v-if="!isH5" class="page-title">通知小助手</p>
      <Header class="msg-page-title" v-else-if="!isHXApp" title="通知小助手" />
      <ul
        v-if="dataList.length"
        class="list-wrap"
        :class="{ 'app-list-wrap': isHXApp }"
        @scroll="handleScroll"
      >
        <li v-for="item in dataList" :key="item.id" class="item-wrap">
          <p class="title">{{ item.title }}</p>
          <div class="msg-content" v-html="handleContent(item.content)" />
          <div class="bottom">
            <p class="time">
              {{ moment(item.created_at * 1000).format("YYYY.MM.DD HH:mm:ss") }}
            </p>
            <button
              v-if="item.msg_href"
              class="detail-btn"
              @click="openHref(item)"
            >
              查看详情 <i class="el-icon-arrow-right" />
            </button>
          </div>
        </li>
      </ul>
      <el-empty
        class="msg-empty"
        v-else
        description="暂无内容"
        :image="emptyImage"
      ></el-empty>
    </div>
  </div>
</template>

<script>
import { EventBus } from "@saas/components/src/utils/event-bus";
import moment from "moment";
import { getMsgList } from "@saas/server-api/src/msg";
import { Header, isHXApp, isH5, getCdnUrl } from "@saas/components/src";
export default {
  data() {
    return {
      isHXApp: isHXApp(),
      isH5: isH5(),
      dataList: [],
      total: 0,
      page_no: 1,
      page_size: 10,
      moment,
      noMore: false,
      isLoading: false,
      isElectron: window.isElectron,
      emptyImage: getCdnUrl("/cdn/static/images/empty.png"),
    };
  },
  mounted() {
    this.apiGetMsgList();
  },
  components: {
    Header,
  },
  methods: {
    handleContent(content) {
      const arr = content.split("<br>");
      arr.forEach((item, index) => {
        arr[index] = "<p>" + item + "</p>";
      });
      return arr.join("");
    },
    openHref(item) {
      // 客户端
      const { template_id, msg_href } = item;
      let url = process.env.VUE_APP_SAAS_WEB_URL + msg_href;
      if (template_id === 8) {
        url += "&tab=all";
      }
      if (window.isElectron) {
        window.openUrlByExternal(url);
      } else if (this.isHXApp) {
        this.$showToast("详细信息在管理后台查看");
      } else {
        window.open(url);
      }
    },
    // 监听列表滚动
    handleScroll(event) {
      if (this.noMore || this.isLoading) return false;
      const { scrollTop, scrollHeight, clientHeight } = event.target;
      // 触底-加载下一页
      if (scrollTop + clientHeight >= scrollHeight - 20) {
        this.isLoading = true;
        this.page_no++;
        this.apiGetMsgList();
      }
    },
    // 全部数据分页加载
    apiGetMsgList() {
      this.isLoading = true;
      const params = {
        id: 0,
        page_no: this.page_no,
        page_size: this.page_size,
      };
      getMsgList(params).then((res) => {
        if (res.code === 1) {
          let data = res.data?.list || [];
          if (params.page_no === 1) {
            this.dataList = data;
            // 消息-已读
            EventBus.$emit("msg-state");
          } else {
            this.dataList = this.dataList.concat(data);
          }
          this.total = res?.data?.total || 0;
          if (this.dataList.length === this.total) {
            this.noMore = true;
          }
        } else {
          this.$message.error(res.message);
        }
        this.isLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.msg-list-page {
  padding: 15px 0;
  height: 100vh;
  .msg-list-count {
    max-width: 1200px;
    width: 100%;
    background: #ffffff;
    border-radius: 16px;
    margin: 0 auto;
    height: 100%;
  }
  .page-title {
    padding: 20px;
    font-weight: 600;
    font-size: 18px;
    color: #0d1400;
    line-height: 25px;
    border-bottom: 1px solid #efefef;
  }
  .list-wrap {
    height: calc(100% - 70px);
    overflow-y: auto;
    padding-bottom: 10px;
  }
  .item-wrap {
    padding: 15px 20px;
    border-bottom: 1px solid #efefef;
    .title {
      font-weight: 600;
      font-size: 16px;
      color: #0d1400;
      line-height: 22px;
      margin-bottom: 10px;
    }
    ::v-deep .msg-content {
      font-weight: 400;
      font-size: 16px;
      color: #0d1400;
      line-height: 26px;
      word-break: break-all;
      p {
        margin-bottom: 10px;
        line-break: anywhere;
      }
    }
    .bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .time {
        font-weight: 400;
        font-size: 14px;
        color: #515350;
        line-height: 20px;
      }
      .detail-btn {
        font-weight: 400;
        font-size: 12px;
        color: #00c89d;
        line-height: 1;
        i {
          line-height: 1;
          margin-left: 1px;
        }
      }
    }
  }
  .msg-empty {
    height: 80%;
  }
}

// mobile
.msg-list-mobile .msg-list-count {
  height: 100vh;
  .msg-page-title {
    position: fixed;
  }
  .list-wrap {
    padding: 1.33rem 0;
    background: #f7f8f9;
    height: 100%;
    overflow-y: auto;
  }
  .app-list-wrap.list-wrap {
    padding: 0.13rem 0 1.33rem;
  }
  .item-wrap {
    margin: 0 auto;
    width: 9.36rem;
    background: #ffffff;
    border-radius: 0.32rem;
    margin-bottom: 0.32rem;
    .title {
      padding: 0.32rem;
      border-bottom: 1px solid #efefef;
      font-weight: 600;
      font-size: 0.4rem;
      color: #0d1400;
      line-height: 0.56rem;
    }
    ::v-deep .msg-content {
      padding: 0.24rem 0.32rem 0.08rem;
      font-weight: 400;
      font-size: 0.4rem;
      color: #0d1400;
      line-height: 0.56rem;
      word-break: break-all;
      p {
        margin-bottom: 0.16rem;
        line-break: anywhere;
      }
    }
    .bottom {
      padding: 0.32rem 0;
      margin: 0 0.32rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-top: 1px solid #efefef;
      .time {
        font-weight: 400;
        font-size: 0.32rem;
        color: #515350;
        line-height: 0.44rem;
      }
      .detail-btn {
        font-weight: 400;
        font-size: 0.32rem;
        color: #00c89d;
        line-height: 0.44rem;
        i {
          line-height: 1;
          margin-left: 1px;
        }
      }
    }
  }
  .msg-empty {
    height: 100%;
  }
}

// 客户端
.msg-list-page.electron-msg-list-page {
  height: calc(100vh - 70px);
}
</style>
